import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "src/_cores/_api/api";
import { ROUTE_NAME } from "src/_cores/_enums/route-config.enum";
import { Autoplay, Pagination, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { PaginationOptions } from "swiper/types/modules/pagination";

/* const autoplay = {
  delay: 2500,
  disableOnInteraction: false,
};  */

const pagination: PaginationOptions = {
  clickable: true,
  renderBullet: function (index: number, className: string) {
    return `<span class='w-[30px] h-[3px] bg-[#FFFFFF80] rounded-none ${className}'></span>`;
  },
};

interface IBanner {
  bannerId: number;
  bannerPath: string;
  status: number | null;
}

const Banner = () => {
  const location = useLocation();
  const [hideBanner, setHideBanner] = useState(false);
  const [banners, setBanners] = useState<IBanner[]>([]);

  useEffect(() => {
    const hiddenPath = [
      ROUTE_NAME.LOOK_UP_ORDERS,
      '/product-detail',
      '/cart',
      '/login',
      '/forget-password',
      '/sign-up',
      '/brands',
    ];
    if (hiddenPath.includes(location.pathname)) {
      setHideBanner(true);
    }

    async function fetchBannerImages() {
      setBanners([]);
      const response = await api.get('/cms/banners') as any;
      setBanners(response?.data ?? []);
    }
    fetchBannerImages();
  }, [location.pathname]);

  return (
    <div className={`${hideBanner ? 'hidden' : ''}`}>
      <Swiper
        className={`banner-slider`}
        loop={true}
        slidesPerView={1}
        navigation={true}
        pagination={pagination}
        style={{ height: "calc(20vw*1.72)", minHeight: "33vw" }}
        modules={[Autoplay, Pagination, Navigation]}
      >
        {banners.map((banner) =>
          <SwiperSlide key={banner.bannerId}>
            <img
              src={process.env.REACT_APP_IMAGE_URL + `/banner/${banner.bannerPath}`}
              alt=""
            />
          </SwiperSlide>
        )}
      </Swiper>
    </div>
  );
};

export default Banner;
